import {
  GET_DROPDOWN_FAILED,
  GET_DROPDOWN_SUCCESS,
} from "../actions/Dropdown/DropdownTypes";

// Initial state
const initialState = {
  dropDownValues: {},
  success: "",
  error: "",
  showLoading: false,
};

// Reducer function
const DropDownReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DROPDOWN_FAILED:
      return {
        ...state,
        error: action.payload,
        showLoading: false,
      };
    case GET_DROPDOWN_SUCCESS:
      return {
        ...state,
        error: "",
        success: "",
        showLoading: false,
        dropDownValues: action.payload,
      };

    default:
      return state;
  }
};

export default DropDownReducer;
